import { useParams } from 'react-router-dom'
import { ReviewView } from '../ReviewView/ReviewView.tsx'

/** `/audits/:auditId/review` — where doubts get decided (§10.3). */
export function ReviewPage() {
  const { auditId } = useParams<{ auditId: string }>()
  if (!auditId) return null
  return <ReviewView auditId={auditId} />
}
